export const scrollToPosition = (id: any) => {
  let element = document.getElementById(id);
  if (element !== null) {
    element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  } else {
    alert(1);
  }
};
